import { ApplicationConfig, provideBrowserGlobalErrorListeners, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';
import { provideServiceWorker } from '@angular/service-worker';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { SERVICE_WORKER } from '@angular/fire/compat/messaging';
import { definePreset } from '@primeuix/styled';

const firebaseConfig = {
  apiKey: "AIzaSyB9bFEP1vTgGdzbpy-z1C3KQyz73ag99Rg",
  authDomain: "prowa-303110.firebaseapp.com",
  projectId: "prowa-303110",
  storageBucket: "prowa-303110.appspot.com",
  messagingSenderId: "143488964357",
  appId: "1:143488964357:web:d3dadf4696a57b29a3496c"
};

const CustomPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#f5f6fe",
      100: "#e7e8fc",
      200: "#d0d1f9",
      300: "#aaabef",
      400: "#8183e3",
      500: "#595bd8",
      600: "#4b4db8",
      700: "#3e3f98",
      800: "#313278",
      900: "#252659",
      950: "#1a1b3e"
    },
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes), provideClientHydration(withEventReplay()),
    providePrimeNG({
      theme: {
        preset: CustomPreset,
        options: {
          darkModeSelector: '.app-dark'
        }
      }
    }),
    provideHttpClient(withFetch()),
    provideTransloco({
      config: {
        availableLangs: ['it', 'en', 'es', 'de', 'fr', 'sq'],
        defaultLang: typeof navigator !== 'undefined' ? navigator.language.split("-")[0] : 'it',
        fallbackLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }),
    provideTranslocoPersistLang({
      storage: {
        useValue: getSafeStorage(),
      },
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    { provide: FIREBASE_OPTIONS, useValue: firebaseConfig },
    { provide: SERVICE_WORKER, useFactory: () => typeof navigator !== 'undefined' && navigator.serviceWorker?.register('firebase-sw.js', { scope: '__' }) || undefined },
    {
      provide: 'message',
      useFactory: () => {
        if (typeof window === 'undefined') {
          return null;
        }

        const appKey = (window as any).__PROWA_APP_KEY__;
        return typeof appKey === 'string' && appKey.length === 32 ? appKey : null;
      }
    }
  ]
};

// TODO: spostare in un file dedicato!
function getSafeStorage(): Storage {
  if (typeof localStorage !== 'undefined') {
    return localStorage;
  }

  const mem = new Map<string, string>();
  return {
    get length() {
      return mem.size;
    },
    clear: () => mem.clear(),
    getItem: (key: string) => (mem.has(key) ? mem.get(key)! : null),
    key: (index: number) => Array.from(mem.keys())[index] ?? null,
    removeItem: (key: string) => {
      mem.delete(key);
    },
    setItem: (key: string, value: string) => {
      mem.set(key, value);
    },
  } as Storage;
}
